import {useNavigate, useParams} from "react-router-dom";
import {fetchWithToken, postWithToken} from "../../../api/apiBase";
import {useAuthInfo} from "@propelauth/react";
import React, {useContext, useEffect, useState} from "react";
import {BaseScopeModel, FullScopeModel} from "../ScopeModel";
import {blank_bid} from "../../bid/bidding_model";
import DataSheet from "../../project_conf/DataSheet";
import {Cell, linesDecoder} from "../../project_conf/bidConfig_model";
import {ScopeForm} from "../ScopeForm";
import {Card, CardContent, CardHeader, CardTitle} from "../../ui/card";
import {EdtSaveButtonToggle} from "../../ui/EdtSaveButtonToggle";
import BidSummary from "../../bid/BidTableView";
import AuctionStatusView from "../../builder/AuctionStatusView";
import {BidFilesCard} from "../../bid/BidFilesCard";


// -----------------------------------------------------------------------------------
export function BidderScopeView() {
    const navigate = useNavigate();
    const {accessToken} = useAuthInfo();
    const {project_id, scope_id} = useParams<string>();
    const [feedback, setFeedback] = useState<any | null>(null);
    const [round, setRound] = useState<any | null>(null);
    const [data, setData] = useState<FullScopeModel | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [sheetData, setSheetData] = useState<Cell[][]>([]);

    useEffect(() => {
        const fetchData = async () => {
            if (accessToken) {
                try {
                    setIsLoading(true);
                    const [response, config, summary, round] = await Promise.all([
                        fetchWithToken(`/projects/${project_id}/scope/${scope_id}`, accessToken),
                        // the scope's SOV - builders only get the bidder lines
                        fetchWithToken(`/projects/${project_id}/sov?scope_id=${scope_id}`, accessToken),
                        fetchWithToken(`/projects/${project_id}/feedback/?scope_id=${scope_id}`, accessToken),
                        fetchWithToken(`/projects/${project_id}/current_round`, accessToken)
                    ]);
                    setData(response);
                    setSheetData(config ? linesDecoder(config.lines) : []);
                    setFeedback(summary);
                    setRound(round);
                    setError(null);

                } catch (err) {
                    setError("Error loading scopes");
                } finally {
                    setIsLoading(false);
                }
            }
        };
        fetchData();
    }, [project_id, scope_id]);

    const noop = (a: any) => {
    }

    return <><Card>
            {data ?
                <ScopeForm
                    editable={false}
                    onSave={noop}
                    onSubmit={noop}
                    scope={data as FullScopeModel}
                    create={false}
                    aside={data.root?.id ?
                        <BidFilesCard
                            key={scope_id}
                            folder_id={data.root.id}
                            canEdit={false}
                            parent_type="scope"
                            parent_id={scope_id}/>
                        : undefined}
                /> : <></>}

    </Card>
        {/*Summary data*/}
        <br/>
        {round && feedback ?
            <AuctionStatusView
                round={round}
                bidViewData={feedback}/>
            : <></>
        }
        <BidSummary/>
        <br/>
        <Card>
            {/*bid config*/}
            <CardHeader>
                <CardTitle>Requirements</CardTitle>
            </CardHeader>
            <CardContent>
                <DataSheet
                    data={sheetData}
                    setData={setSheetData}
                    enable_row_col={false}
                    readonly={true}
                />
            </CardContent>
        </Card>
    </>
}

